export const mobileScreen = window.matchMedia("(max-width: 576px)");
export default mobileScreen.matches;
